export default "__VITE_ASSET__8ed69d7c__"